import { Component, EventEmitter, OnInit, OnDestroy, Output,ElementRef,ViewChild } from '@angular/core';
import { GastroFormsService } from 'src/app/gastro-forms.service';
import { LoginService } from 'src/app/login.service';
import { Subscription,fromEvent,Subject, } from 'rxjs';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';
import {  tap, switchMap, takeUntil, finalize} from 'rxjs/operators';

@Component({
    selector: 'app-admission',
    templateUrl: './admission.component.html',
    styleUrls: ['./admission.component.scss'],
    standalone: false
})

export class AdmissionComponent implements OnInit, OnDestroy {
  private formLoadedSub: Subscription;
  @ViewChild("canvasSign", { static: true })
  canvasSign: ElementRef<HTMLCanvasElement>;
  changeCanvas$ = new Subject();
  destroy$ = new Subject<void>();
  ctx: CanvasRenderingContext2D;

  constructor(
    public gastroFormsService: GastroFormsService,
    public autoTextService: AutotextService,
    public examService: ExamsService,
    private ls: LoginService
  ) {}

  @Output() closed = new EventEmitter<string>();
  @Output() print = new EventEmitter<string>();

  async ngOnInit() {
    this.gastroFormsService.Form.disable({ emitEvent: false });
    this.formLoadedSub = this.gastroFormsService.formLoaded$.subscribe(
      (data: any) => {
        if (this.gastroFormsService.Form && this.gastroFormsService.Form.get('nurseSign').value) {
          this.loadSign();
        }
        if (!data.AdmissionTime) {
          const creationTime = new Date(data.CreationTime);
          const formattedTime = this.formatTime(creationTime);
          this.gastroFormsService.Form.get("AdmissionTime").patchValue(
            formattedTime
          );
        }

        this.gastroFormsService.Form.enable({ emitEvent: false });
      }
    );
  }

  close(toclose: boolean) {
    this.closed.emit(toclose ? '1': null);
  }
  printForm(){
    this.print.emit('1')
  }

  ngAfterViewInit(){
     this.changeCanvas$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.ctx = data.ctx;
        const mouseDownStream = fromEvent(
          this.canvasSign.nativeElement,
          "mousedown"
        );
        const mouseMoveStream = fromEvent(
          this.canvasSign.nativeElement,
          "mousemove"
        );
        const mouseUpStream = fromEvent(window, "mouseup");
        mouseDownStream
          .pipe(
            tap((event: MouseEvent) => {
              this.ctx.beginPath();
              this.ctx.strokeStyle = "black";
              this.ctx.lineWidth = 5;
              this.ctx.lineJoin = "round";
              this.ctx.moveTo(event.offsetX, event.offsetY);
            }),
            switchMap(() =>
              mouseMoveStream.pipe(
                tap((event: MouseEvent) => {
                  this.ctx.lineTo(event.offsetX, event.offsetY);
                  this.ctx.stroke();
                }),
                takeUntil(mouseUpStream),
                finalize(() => {
                  // this.ctx.closePath();
                  this.saveSign();
                })
              )
            )
          )
          .subscribe((data) => {
            // console.log(data);
          });
      });
  }

  getClass(item):string{
    if(item !== null  && this.gastroFormsService.Form.get(item+'Note')  && this.gastroFormsService.Form.get(item+'Note').value )
      return 'type-v'
    return 'type-plus';
  }

  formatTime(date: Date): string {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  resetFormField(fromValue: string = "") {
    this.gastroFormsService.Form.get(fromValue).setValue(null);
  }

  ngOnDestroy(): void {
    if (this.formLoadedSub) {
      this.formLoadedSub.unsubscribe();
    }
    this.destroy$.next()
    this.destroy$.complete()
  }

  clearSign() {
    var ctx = this.canvasSign.nativeElement.getContext("2d");
    ctx.clearRect(
      0,
      0,
      this.canvasSign.nativeElement.width,
      this.canvasSign.nativeElement.height
    );
    this.gastroFormsService
.Form.get('nurseSign').setValue('');
  
  
  }
  
  setCanvas() {
    this.ctx = this.canvasSign.nativeElement.getContext("2d");
    this.changeCanvas$.next({ canvas: this.canvasSign, ctx: this.ctx });
  }
  
  saveSign() {
    let canvasUrl = this.canvasSign.nativeElement.toDataURL("image/png");
        this.gastroFormsService
.Form.get("nurseSign").setValue(canvasUrl);
       
    }
  
    loadSign(){
      var ctx = this.canvasSign.nativeElement.getContext("2d");
        const imgNurseSign = document.createElement("img");
        imgNurseSign.onload = function () {
          ctx.drawImage(imgNurseSign, 0, 0); // Or at whatever offset you like
        };
        imgNurseSign.src = this.gastroFormsService
.Form.get("nurseSign").value;
    }
}
